var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-lg-3 mt-1 pt-3 pb-0 px-3"},[_c('VirtualDeviceList'),(!_vm.showingBottomNav)?_c('FloatingActionButton'):_vm._e(),_c('InfoModal'),_c('ErrorModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }